import React from 'react';
import { AccordionDetails } from '@mui/material';
import { ReactComponent as ExpandMore } from 'assets/icons/arrow-down.svg';
import AdditionalInfo from './AdditionalInfo';
import { AccordionSummaryStyled, ExpandMoreIconStyled, LabelStyled, AccordionStyled } from './AccordionStyles';

const DS_AccordionElementMUI = ({ disable = false, expandedAlways = false, data, isRichTextValue = false }) => {
  return (
    <AccordionStyled
      sx={{ boxShadow: 0, position: 'inherit' }}
      defaultExpanded={data.isOpenedByDefault}
      data-test="accordion-wrapper"
    >
      <AccordionSummaryStyled
        disabled={disable}
        data-test="accordion-summary"
        $expandedAlways={expandedAlways}
        expandIcon={<ExpandMoreIconStyled component={ExpandMore} inheritViewBox />}
        aria-controls={data.id}
        id={data.id}
      >
        <LabelStyled variant="DS_copyMediumBold" component="span" $expandedAlways={expandedAlways}>
          {data.label}
        </LabelStyled>
      </AccordionSummaryStyled>

      <AccordionDetails data-test="accordion-details">
        <AdditionalInfo
          data-test="accordion-info"
          data={data}
          expandedAlways={expandedAlways}
          isRichTextValue={isRichTextValue}
        />
      </AccordionDetails>
    </AccordionStyled>
  );
};

export default DS_AccordionElementMUI;
